import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { AppBarProps, Button, Divider, Tooltip } from '@mui/material';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import MenuIcon from '../../icons/Menu';
import AccountPopover from './AccountPopover';
import PayLogo from '../../logos/PayLogo';
import { remoteRoutes } from '../../constants';
import LumenLogo from '../../logos/LumenLogo';
import MessagingLogo from '../../logos/MessagingLogo';
import { useTheme } from '@mui/material/styles';

interface DashboardNavbarProps extends AppBarProps {
  onSidebarMobileOpen?: () => void;
}

const products = [
  {
    name: 'Pay',
    logo: <PayLogo sx={{ width: 30, height: 30, }}/>,
    url: remoteRoutes.pay
  },
  {
    name: 'Lumen',
    logo: <LumenLogo sx={{ width: 28, height: 28, }}/>,
    url: remoteRoutes.lumen
  },
  {
    name: 'Messaging',
    logo: <MessagingLogo sx={{ width: 30, height: 30, }}/>,
    url: remoteRoutes.messaging
  },
];

const DashboardNavbar: FC<React.PropsWithChildren<DashboardNavbarProps>> = (props) => {
  const theme = useTheme();
  const { onSidebarMobileOpen, ...other } = props;

  return (
      <AppBar
          {...other}
          sx={{
            backgroundColor: theme.palette.background.paper,
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
      >
          <Toolbar>
              <IconButton
                  color="inherit"
                  size="large"
                  sx={{
                    display: {
                      lg: 'none',
                      md: 'block'
                    }
                  }}
                  onClick={onSidebarMobileOpen}
              >
                  <MenuIcon
                      fontSize="small"
                      color="action"
                  />
              </IconButton>
              <Box
                  sx={{
                    flexGrow: 1,
                    ml: 2
                  }}
              />
              <Box
                  sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    borderRadius: 1,
                    py: 0.4,
                    backgroundColor: theme.palette.background.default,
                  }}
              >
                  {
                      products.map((product, index) => (
                          <Tooltip
                              key={index}
                              title={product.name}
                          >
                              <Button
                                  href={product.url}
                                  target="_blank"
                              >
                                  {product.logo}
                              </Button>
                          </Tooltip>
                      ))
                  }
              </Box>
              <Divider sx={{ height: 40, mx: 2, width: 2, backgroundColor: theme.palette.divider }}/>
              <Box>
                  <AccountPopover/>
              </Box>
          </Toolbar>
      </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
};

export default DashboardNavbar;
